module.exports = __webpack_public_path__ + "static/UAdeskSlide1-daea912683616eb96c7e580e2897bf69.png";